The value of `Event.id` for the requested object.
